export default "__VITE_ASSET__BpYirg1F__"